export const createCrashTrackUriChunk = (
  assetId: string,
  timestamp: string | number
) => `${assetId}__${timestamp}`;
